module.exports = __webpack_public_path__ + "img/IlliquidsLogo.0f904f8a.svg";